const backToTopActive = ref(false);

export default () => {
  return { backToTopActive };
};
